export const HOSTINGER_PURPLE = "#673DE6";
export const HOSTINGER_BG = "#F5F6FB";
